import styled from 'styled-components';
import image from './../../_static/others/ballons.jpg';
import logo from './../../_static/logo.png';

export const LoginBackgroundImage = styled.div`
    width: 100%;
    height: 100vh;
    margin: 0;
    top: 0;
    left: 0;
    background: url(${image}) center center no-repeat;
    background-size: cover;    
    
    .loading {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 9999;
    }
    
    .brand-title {
        font-size: 32px;
        font-family: Lato, sans-serif;
        letter-spacing: -1px;
        font-weight: 300;
    }
    
    .logo {
        position: relative;
        background: url(${logo}) center center no-repeat;        
        background-size: contain;
        height: 160px;
        min-width: 50px;
        width: 100%;        
    }
`;

export const CenterLogin = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center
`;

export const CardLogin = styled.div`
    background-color: rgba(255,255,255);
    min-width: 470px;
    max-width: 500px;
    opacity: 0.93;
    padding-top: 20px;  
`;

export const AlertError = styled.div`
    background-color: red;
    border-radius: 5px;
    color: white;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    padding: 5px
`;

